// extracted by mini-css-extract-plugin
module.exports = {"label":"idt-engravinginputremoveselection_label__15l4g"};